// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function Motto() {
  return (
    <MKBox component="section" py={{ xs: 0, sm: 6 }}>
      <Container xs={12} sx={{ position: "relative", zIndex: 2, py: 12 }}>
        <Grid
          container
          item
          md={7}
          justifyContent="center"
          mx="auto"
          textAlign="center"
          direction="column"
        >
          <MKTypography variant="h4" color="dark">
            Our motto
          </MKTypography>
          <MKTypography
            variant="h1"
            color="info"
            mb={6}
            sx={({ breakpoints, typography: { size } }) => ({
              [breakpoints.down("md")]: {
                fontSize: size["xl"],
              },
            })}
          >
            #Keep Growing And Getting Stronger
          </MKTypography>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Motto;
